// Sizes, units, and words a short name should not end on
const SIZE_UNIT = /^(cl|ml|l|lt|lts|litros?|g|gr|grs|kg|uds?|unidades?)$/i;
const LINKING_WORDS = new Set(['con', 'de', 'del', 'y', 'e', 'a', 'la', 'el', 'los', 'las', 'para', 'sin', 'en', '&']);

/**
 * A product name short enough for a sentence: its first words without sizes, up to what comes after a slash, dash or
 * bracket ("AGUA 1/2 LT. VIDAQUA" → "Agua Vidaqua", "SANDWICH CLASIC ÑAMING / LM" → "Sandwich Clasic"). `loose` reads
 * further, to tell two names apart that start the same.
 */
export const shortName = (name, loose = false) => {
  const maxLength = loose ? 28 : 16;
  const kept = [];
  for (const raw of String(name || '').split(/\s+/)) {
    const word = raw.replace(/[.,´']+$/, '');
    if (!word || /\d/.test(word) || SIZE_UNIT.test(word)) continue;
    if (/^[/(\-–+]/.test(word)) {
      if (kept.length && !loose) break;
      continue;
    }
    const [head] = word.split('/');
    if (word.includes('/')) {
      if (head.length > 1 && [...kept, head].join(' ').length <= maxLength) kept.push(head);
      if (kept.length && !loose) break;
      continue;
    }
    if (kept.length && [...kept, word].join(' ').length > maxLength) break;
    kept.push(word);
  }
  while (kept.length > 1 && LINKING_WORDS.has(kept[kept.length - 1].toLowerCase())) kept.pop();
  const text = kept.join(' ') || String(name || '').trim();
  // An all-caps name reads as shouting inside a sentence
  if (text !== text.toUpperCase()) return text;
  return text.toLowerCase().split(' ')
    .map((w, i) => (i > 0 && LINKING_WORDS.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1))).join(' ');
};

/** Both names of a swap, read further when they start the same. */
export const swapNames = (from, to) => {
  const pair = [shortName(from), shortName(to)];
  return pair[0] !== pair[1] ? pair : [shortName(from, true), shortName(to, true)];
};
